const AREA_LIST_KEY = 'areaList'
export default {
  getLocalAreaList(query) {
    let data = localStorage.getItem(AREA_LIST_KEY)
    if (data) {
      let parsedArr =  JSON.parse(data)
      if (query && query.area_type) {
        parsedArr = parsedArr.filter(item => item.area_type == query.area_type)
      }

      return parsedArr
    }
    return null
  },

  setLocalAreaList(data) {
    localStorage.setItem(AREA_LIST_KEY, JSON.stringify(data))
  },

  removeLocalAreaList() {
    localStorage.removeItem(AREA_LIST_KEY)
  }
}
